<template>
  <div>
    <div class="form-container">
      <div class="form-title margin-b10">评价办法管理</div>
      <div class="base-detail-box">
        <el-form
          :inline="true"
          :model="formData"
          class="demo-form-inline"
          :rules="rules"
          label-width="110px"
        >
          <el-row style="margin-bottom: 0">
            <el-col :span="12" style="margin-bottom: 0">
              <el-form-item
                label="评价编码："
                class="base-detail"
                style="margin-bottom: 0"
              >
                {{ tableObj.evaluationCode }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="评价办法：">{{
                tableObj.evaluateMethodName
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="专业：">{{
                tableObj.specialtyName
              }}</el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="适用范围：">{{
                tableObj.supplierType
              }}</el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="现场审查费：">
                ¥ {{ tableObj.evaluationInfo.siteReviewFee }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="form-container">
      <div class="form-title margin-b20">范围</div>
      <div class="way-wrapper">
        <div class="way-text">
          {{ tableObj.evaluationInfo.scope }}
        </div>
      </div>
    </div>

    <!-- 主编单位 -->
    <DraftCompany
      :draftCompanyList="tableObj.evaluationInfo.draftCompanyList"
    ></DraftCompany>

    <!-- 规范性引用 -->
    <EvaluationSpecification
      :evaluationSpecificationList="evaluationSpecificationList"
    ></EvaluationSpecification>
    <!-- 权重 -->
    <div class="form-container">
      <div class="form-title margin-b10">权重</div>
      <div class="base-detail-box">
        <el-form
          :inline="true"
          :model="formData"
          class="demo-form-inline"
          :rules="rules"
          label-width="110px"
        >
          <el-row style="margin-bottom: 0">
            <el-col :span="12" style="margin-bottom: 0">
              <el-form-item
                label-width="200"
                label="工厂现场评审(生产保障能力)："
                class="base-detail"
                style="margin-bottom: 0"
              >
                工厂现场评审(生产保障能力)：
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="产品性能测试："
                >评价办法评价办法评价办法评价办法</el-form-item
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 表1 -->
    <TableOne
      :evaluationBasicQualificationList="
        tableObj.evaluationBasicQualificationList
      "
    ></TableOne>

    <!-- 表2 -->
    <TableTwo
      :evaluationProduceAbilityList="tableObj.evaluationProduceAbilityList"
    ></TableTwo>

    <!-- 表三 -->
    <TableThree
      :evaluationProductList="tableObj.evaluationProductList"
    ></TableThree>

    <!-- 表4 - 表5 -->
    <template v-if="supplierType !== '103'">
      <div
        class="form-container"
        v-for="(item, index) in tableObj.evaluationProductPerformanceList"
        :key="index"
      >
        <div class="table-title-info">
          <div
            class="title-content"
            :style="{
              'margin-bottom':
                showCover(item.productName).length > 0 ? '10px' : 0
            }"
          >
            <h2 class="title">
              {{ `表4-${index + 1}${item.productName}检测内容和依据` }}
            </h2>
            <div class="title-handle-btn">
              <div class="table-handle-btn">
                展开收起
                <!-- eicon-arrow-down -->
                <eui-icon icon="eicon-arrow-up" color="#0064C8"></eui-icon>
              </div>
            </div>
          </div>
          <div class="table-info" v-if="showCover(item.productName).length > 0">
            <div class="label">覆盖等级：</div>
            <div class="text">
              <span v-for="pName of showCover(item.productName)"
                >{{ pName.productName }}、</span
              >
              <!-- BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
            001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
            0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
            0012、BB3离心泵 001、BB3离心泵 0031、BB3离心泵 0011、BB3离心泵
            001、BB3离心泵 001、BB3离心泵 001、BB3离心泵 0011、BB3离心泵
            0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵 0012、BB3离心泵
            0012、 -->
            </div>
          </div>
        </div>
        <div>
          <!-- 表4 -->
          <div>
            <div class="table-wrapper table-4">
              <div class="table-header-wrapper">
                <div class="table-header">
                  <div class="table-header-item one">检测项目</div>
                  <div class="table-header-item two">技术要求</div>
                  <div class="table-header-item three">检测依据</div>
                  <div class="table-header-item four">备注</div>
                  <div class="table-header-item five">产品性能评分</div>
                </div>
              </div>
              <div class="table-body-wrapper">
                <div class="table-body">
                  <div
                    class="table-body-item"
                    v-for="(itemFourDetail,
                    indexFourDetail) in item.performanceDetectItemList"
                  >
                    <div class="one">{{ itemFourDetail.detectItem }}</div>
                    <div class="two">{{ itemFourDetail.techRequirement }}</div>
                    <div class="three">{{ itemFourDetail.reference }}</div>
                    <div class="four">{{ itemFourDetail.remark }}</div>
                    <div class="five">
                      <eui-icon
                        icon="eicon-check-press"
                        color="#D9D9D9"
                        font-size="16px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 表5 -->
          <div
            style="margin-top: 20px;"
            v-for="(fiveItem, fiveIndex) in handleTableFourFive(
              item.productName
            )"
          >
            <div class="table-outer-title">
              <div style="font-size: 14px;">
                <div>
                  {{ `表5-${index + 1}${fiveItem.productName}产品性能测试表` }}
                </div>
              </div>
            </div>
            <div class="table-wrapper table-1">
              <div class="table-header-wrapper">
                <div class="table-header">
                  <div class="table-header-item one" style="flex: 1">
                    检测项目
                  </div>
                  <div class="table-header-item two" style="flex: 1">备注</div>
                  <div class="table-header-item three">分级范围</div>
                  <div class="table-header-item four">分值</div>
                </div>
              </div>
              <div class="table-body-wrapper">
                <div class="table-body">
                  <div
                    class="table-body-item"
                    v-for="(fiveItem1,
                    fiveIndex1) in fiveItem.productBenchmarkItemList"
                    :key="fiveIndex1"
                  >
                    <div class="one" style="flex: 1">
                      {{ fiveItem1.detectItem }}
                    </div>
                    <div class="one" style="flex: 1">
                      {{ fiveItem1.scoreRemark }}
                    </div>
                    <div class="two" style="display: block; flex: 4">
                      <div
                        class="table-body-wrapper-inner"
                        style="display: block"
                      >
                        <div class="table-body-inner">
                          <div
                            class="table-body-item-inner"
                            v-for="(fiveItem2,
                            fiveIndex2) in fiveItem1.evaluationProductPerformanceGradeList"
                            :key="fiveIndex2"
                          >
                            <div class="two" style="flex: 2">
                              {{ fiveItem2.gradeRange }}
                            </div>
                            <div class="three" style="flex: 2">
                              {{ fiveItem2.score }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="table-body-wrapper-inner"
                        style="display: block"
                      >
                        <div class="table-body-inner">
                          <div
                            class="table-body-item-inner"
                            style="border-top: 1px solid #dcdcdc"
                          >
                            <div
                              class="one"
                              style="flex: 6; font-weight: 500; display: flex; justify-content: flex-end; align-items: center;"
                            >
                              <div style="margin-right: 20px">
                                <span style="margin-right: 10px">{{
                                  fiveItem1.detectItem
                                }}</span>
                                <span>合计{{ fiveItem1.score }}分</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 抽样规则录入 -->
    <div class="form-container" v-if="supplierType !== '103'">
      <div class="form-title margin-b20">抽样规则录入</div>
      <div class="way-wrapper">
        <div class="way-text" style="text-indent: 0;">
          {{ tableObj.evaluationInfo.samplingRule }}
        </div>
      </div>
    </div>

    <!-- 评价费用 -->
    <div class="form-container">
      <div class="form-title margin-b20">评价费用</div>
      <div class="table-wrapper">
        <ETableList
          :table-data="tableObj.evaluationProductList"
          :table-label="tableLabel"
        >
          <template #amount="{scope}">
            <span>{{ scope.row.amount | thousandsSeparator }}</span>
          </template>
          <template #level="{scope}">
            <span>{{ `${scope.row.level}级` }}</span>
          </template>
        </ETableList>
      </div>
      <div>
        <el-form
          :inline="true"
          :model="formData"
          class="demo-form-inline"
          :rules="rules"
          label-width="160px"
          style="margin-top: 14px;"
        >
          <el-row style="margin-bottom: 0">
            <el-col :span="24" style="margin-bottom: 0">
              <el-form-item
                label="产品检测费分项报价："
                class="base-detail-x"
                style="margin-bottom: 0"
              >
                <div
                  style="display: flex; align-items: center;"
                  v-if="tableObj.evaluationAttachment.itemOfferAttachName"
                >
                  <eui-icon
                    icon="eicon-file"
                    color="#666"
                    fontSize="16px"
                    style="margin-right: 4px;"
                  />
                  {{ tableObj.evaluationAttachment.itemOfferAttachName }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0">
            <el-col :span="24" style="margin-bottom: 0">
              <el-form-item
                label="附录文件："
                style="margin-bottom: 0"
                class="base-detail-x"
              >
                <div
                  style="display: flex; align-items: center;"
                  v-if="tableObj.evaluationAttachment.evaluateMethodAttachName"
                >
                  <eui-icon
                    icon="eicon-cgbb"
                    color="#666"
                    fontSize="16px"
                    style="margin-right: 4px;"
                  />
                  {{ tableObj.evaluationAttachment.evaluateMethodAttachName }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 业务咨询人 -->
    <div class="form-container">
      <div class="form-title margin-b20">业务咨询人</div>
      <div class="table-x">
        <div>
          <div class="table-title-box common-box">
            <div class="first-box">业务咨询人</div>
            <div class="second-box">联系方式</div>
            <div class="third-box">邮箱</div>
          </div>
          <div>
            <div
              v-for="(item, index) in evaluationBusinessConsultList"
              :key="index"
              style="border-bottom: 1px solid #dcdcdc"
            >
              <div class="common-box table-content">
                <div class="first-box">
                  {{ item.businessConsultName }}
                </div>
                <div class="second-box">
                  {{ item.businessConsultTel }}
                </div>
                <div class="third-box">
                  {{ item.businessConsultEmail }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="flex-sb">
      <div>
        <eui-btn type="secondary" @click="goBack">返回</eui-btn>
      </div>
      <div>
        <eui-btn type="secondary" style="margin-right: 10px"
          >下载评价办法</eui-btn
        >
        <eui-btn type="secondary">下载评价细则</eui-btn>
      </div>
    </div> -->
  </div>
</template>

<script>
import Api from '@/modules/projectA/api/ESorganization/index';
import { oArrayToTree } from '../componentsData';

import DraftCompany from './draftCompany.vue';
import EvaluationSpecification from './evaluationSpecification.vue';
import TableOne from './tableOne.vue';
import TableTwo from './tableTwo.vue';
import TableThree from './tableThree.vue';

import ETableList from '@/modules/projectA/components/common/e-table-list';
// import FileUpload from './fileUpload.vue';
export default {
  components: {
    DraftCompany,
    EvaluationSpecification,
    TableOne,
    TableTwo,
    TableThree,
    ETableList
    // FileUpload
  },
  data() {
    return {
      tableLabel: [
        {
          label: '检测等级',
          align: 'center',
          minWidth: 140,
          slot: 'level'
        },
        {
          label: '产品名称',
          param: 'productName',
          align: 'center',
          minWidth: 280
        },
        {
          label: '检测费',
          param: 'amount',
          align: 'right',
          minWidth: 140,
          slot: 'amount'
        }
      ],
      evaluationBusinessConsultList: [],
      formData: {},
      rules: {},
      checked: false,
      //
      evaluationSpecificationList: [
        {
          standardCode: '标准号',
          standardName: '标准名称'
        }
      ],
      // 表1
      evaluationBasicQualificationList: [],

      tableObj: {
        tempSaveOrConfirmNext: 1,
        currentStep: 4, // 步走4
        evaluationCode: 'EQE190102001',
        evaluationId: 1687,
        //
        evaluationAttachment: {
          evaluateMethodAttachName: '',
          evaluateMethodAttachPath: '',
          itemOfferAttachName: '',
          itemOfferAttachPath: ''
        },
        evaluationInfo: {
          multiProduct: 1,
          productMultiLevel: 1,
          samplingRule: ''
        },
        // 表2
        evaluationProduceAbilityList: [],
        // 表3
        evaluationProductList: [],
        // 表4
        evaluationProductPerformanceList: [],
        // 表5
        evaluationProductBenchmarkList: []
      },
      coverMap: {},
      supplierType: '',
      evaluationId: 0
    };
  },
  computed: {},
  mounted() {
    this.supplierType = this.$route.query.supplierType || '103';
    this.evaluationId = this.$route.query.evaluationId || '103';
    this.getDetailInfo();
  },
  methods: {
    showCover(productName) {
      return this.coverMap[productName] || [];
    },
    getTotal(arr) {
      return arr.reduce((pre, cur) => {
        return pre + Number(cur.score);
      }, 0);
    },
    oArrayToTree(arr) {
      let result = [];
      if (!Array.isArray(arr) || arr.length === 0) {
        return result;
      }
      let map = {};
      arr.forEach(item => (map[item.nodeId] = item));
      console.log('map:', map); // 对象 为了映射父子关系
      arr.forEach(item => {
        //
        const parent = map[item.parentNodeId];
        if (parent) {
          // (parent.children || (parent.children=[])).push(item);
          if (parent.children) {
            parent.children.push(item);
          } else {
            // 如果 parent 没有 children 属性(顶级) 则赋值为 []
            parent.children = [];
            // 然后push item
            parent.children.push(item);
          }
        } else {
          result.push(item);
        }
      });
      return result;
    },
    async getDetailInfo() {
      const result = await Api.structEvaluationDetail({
        evaluationId: this.evaluationId
      });
      // detailInfo
      console.log(result);
      if (result.code === '200') {
        let {
          evaluationProductList = [],
          evaluationProductPerformanceList = [],
          evaluationProductBenchmarkList = [],
          evaluationProduceAbilityList = [],
          evaluationBasicQualificationList = [],
          coverMap = {},
          evaluationBusinessConsultList = []
        } = result.data;
        this.coverMap = { ...coverMap };
        this.evaluationBusinessConsultList = [...evaluationBusinessConsultList];

        /* evaluationBasicQualificationList = [
          {
            auditItem: '基本资质',
            auditContentCode: '',
            auditContent: '营业执照',
            required: 0,
            eligibility: '在有效期内且经营范围包含被评价产品品种',
            remark: '12',
            sortNum: 1
          },
          {
            auditItem: '生产经营资质',
            auditContentCode: '',
            auditContent: '12',
            required: 0,
            eligibility: '12',
            remark: '12',
            sortNum: 2
          },
          {
            auditContent: '胜多负少的',
            auditContentCode: '',
            auditItem: '生产经营资质',
            eligibility: '发生的方式',
            remark: '胜多负少的',
            required: 1,
            sortNum: 3
          },
          {
            auditContent: '胜多负少的',
            auditContentCode: '',
            auditItem: '生产经营资质',
            eligibility: "东方闪电s'd'f",
            remark: '胜多负少的s',
            required: 0,
            sortNum: 4
          },
          {
            auditContent: '胜多负',
            auditContentCode: '',
            auditItem: '生产经营资质',
            eligibility: '递四方速递',
            remark: '大幅度发给',
            required: 0,
            sortNum: 5
          },
          {
            auditItem: '诚信情况',
            auditContentCode: '',
            auditContent: '对所提供样品及相关资料真实性负责',
            required: 0,
            eligibility: '生产企业承诺所提供样品及相关资料真实有效',
            remark: '12',
            sortNum: 6
          },
          {
            auditItem: '其他',
            auditContentCode: '',
            auditContent: '12',
            required: 0,
            eligibility: '12',
            remark: '12',
            sortNum: 7
          },
          {
            auditContent: '胜多负少的',
            auditContentCode: '',
            auditItem: '其他',
            eligibility: '胜多负12121212',
            remark: '鼎折覆餗',
            required: 0,
            sortNum: 7
          }
        ]; */

        let arr = [
          {
            auditItem: '基本资质',
            auditContentCode: '',
            auditContent: '',
            required: 0,
            eligibility: '',
            remark: '',
            sortNum: 1
          },
          { auditItem: '生产经营资质', children: [] },
          {
            auditItem: '诚信情况',
            auditContentCode: '',
            auditContent: '',
            required: 0,
            eligibility: '',
            remark: '',
            sortNum: 1
          },
          { auditItem: '其他', children: [] }
        ];

        arr.forEach(el => {
          evaluationBasicQualificationList.forEach(item => {
            if (el.auditItem === '基本资质' || el.auditItem === '诚信情况') {
              if (el.auditItem === item.auditItem) {
                el.auditContentCode = item.auditContentCode;
                el.auditContent = item.auditContent;
                el.required = item.required;
                el.eligibility = item.eligibility;
                el.remark = item.remark;
              }
            } else {
              if (el.auditItem === item.auditItem) {
                el.children.push(item);
              }
            }
          });
          console.log(arr, 'arrarrarr');
        });
        // console.log(arr, 'arrarrarr');

        evaluationProduceAbilityList = oArrayToTree(
          evaluationProduceAbilityList
        );
        evaluationProduceAbilityList.forEach(item => (item.isShow = true));
        this.tableObj = {
          ...result.data,
          evaluationProduceAbilityList,
          evaluationBasicQualificationList: arr
        };
        console.log(this.tableObj, 'this.tableObj');
      }
    },

    // 处理表5数据
    handleTableFourFive(productName) {
      const filterFiveList = this.tableObj.evaluationProductBenchmarkList.filter(
        item => item.productName === productName
      );
      return filterFiveList;
    },

    goBack() {
      this.$router.push({
        path: '/ES/ESorganization'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.form-container {
  .table-two-item {
    margin-top: 10px;
    &:first-child {
      margin-top: 0;
    }
  }
  .base-detail-box {
    margin-bottom: -10px;
    ::v-deep .el-form-item__label {
      color: #666;
    }
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 0;
    }
    ::v-deep .el-form-item--small.el-form-item {
      margin-bottom: 0;
    }
  }
  .base-detail-x {
    color: #0064c8;
    font-size: 14px;
    font-weight: 350;
  }
  .table-outer-title {
    height: 40px;
    padding: 0 10px 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #333;
    font-size: 12px;
    font-weight: 500;
    background: #f5f5f5;
    border: 1px solid #dcdcdc;
    border-bottom: none;
    .table-outer-btn {
      color: #0064c8;
      cursor: pointer;
    }
  }
  .table-1 {
    .table-header {
      height: 40px;
      display: flex;
      background: #f5f5f5;
      border: 1px solid #dcdcdc;
      .table-header-item {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 1;
      }
      .two {
        flex: 2;
      }
      .three {
        flex: 2;
      }
      .four {
        flex: 2;
      }
    }
    .table-body-wrapper {
      border: 1px solid #dcdcdc;
      border-top: none;
      .table-body {
        .table-body-item {
          min-height: 50px;
          display: flex;
          color: #333;
          font-size: 12px;
          font-weight: 500;
          border-top: 1px solid #dcdcdc;
          &:first-child {
            border-top: none;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #dcdcdc;
            &:last-child {
              border-right: none;
            }
          }
          .one {
            flex: 1;
          }
          .two {
            flex: 2;
          }
          .three {
            flex: 2;
          }
          .four {
            flex: 2;
          }
        }
      }
    }
  }

  .table-header {
    height: 40px;
    display: flex;
    background: #f5f5f5;
    border: 1px solid #dcdcdc;
    .table-header-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-right: 1px solid #dcdcdc;
      white-space: nowrap;
      &:last-child {
        border-right: none;
      }
    }
    .one {
      flex: 1;
    }
    .two {
      flex: 3;
    }
  }
  .table-body-wrapper {
    border: 1px solid #dcdcdc;
    border-top: none;
    .table-body {
      .table-body-item {
        min-height: 50px;
        display: flex;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-top: 1px solid #dcdcdc;
        &:first-child {
          border-top: none;
        }
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #dcdcdc;
          &:last-child {
            border-right: none;
          }
        }
        .one {
          flex: 1;
        }
        .two {
          flex: 3;
        }
      }
    }
  }
  .way-wrapper {
    line-height: 1;
    .way-text {
      color: #333;
      font-size: 14px;
      font-weight: 350;
      line-height: 22px; /* 157.143% */
      text-indent: 28px;
    }
  }
  /* 嵌套表格 */
  .table-body-wrapper-inner {
    border-top: none;
    .table-body-inner {
      .table-body-item-inner {
        min-height: 50px;
        display: flex;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-top: 1px solid #dcdcdc;
        &:first-child {
          border-top: none;
        }
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #dcdcdc;
          &:last-child {
            border-right: none;
          }
        }
        .one {
          flex: 2;
        }
        .two {
          flex: 1;
        }
        .three {
          flex: 2;
        }
        .four {
          flex: 2;
        }
      }
    }
  }
  .table-3 {
    .table-header {
      height: 40px;
      display: flex;
      background: #f5f5f5;
      border: 1px solid #dcdcdc;
      .table-header-item {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 1;
      }
      .two {
        flex: 3;
      }
      .three {
        flex: 5;
      }
    }
    .table-body-wrapper {
      border: 1px solid #dcdcdc;
      border-top: none;
      .table-body {
        .table-body-item {
          min-height: 50px;
          display: flex;
          color: #333;
          font-size: 12px;
          font-weight: 500;
          border-top: 1px solid #dcdcdc;
          &:first-child {
            border-top: none;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #dcdcdc;
            &:last-child {
              border-right: none;
            }
          }
          .one {
            flex: 1;
          }
          .two {
            flex: 3;
          }
          .three {
            flex: 5;
          }
        }
      }
    }
  }
  .table-title-info {
    padding: 13px 10px 13px 20px;
    border: 1px solid #dcdcdc;
    border-bottom: none;
    background: #f5f5f5;
    .title-content {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .title {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        line-height: 1;
      }
      .title-handle-btn {
        display: flex;
        font-size: 12px;
        .table-handle-btn {
          margin-right: 10px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
    .table-info {
      display: flex;
      color: #666;
      font-size: 14px;
      .label {
        font-weight: 350;
        white-space: nowrap;
      }
    }
  }

  .table-4 {
    .table-header {
      height: 40px;
      display: flex;
      background: #f5f5f5;
      border: 1px solid #dcdcdc;
      .table-header-item {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 1;
      }
      .two {
        flex: 3;
      }
      .three {
        flex: 2;
      }
      .four {
        flex: 2;
      }
      .five {
        flex: 1;
      }
    }
    .table-body-wrapper {
      border: 1px solid #dcdcdc;
      border-top: none;
      .table-body {
        .table-body-item {
          min-height: 50px;
          display: flex;
          color: #333;
          font-size: 12px;
          font-weight: 500;
          border-top: 1px solid #dcdcdc;
          &:first-child {
            border-top: none;
          }
          & > div {
            display: flex;
            justify-content: center;
            align-items: center;
            border-right: 1px solid #dcdcdc;
            &:last-child {
              border-right: none;
            }
          }
          .one {
            flex: 1;
          }
          .two {
            flex: 3;
          }
          .three {
            flex: 2;
          }
          .four {
            flex: 2;
          }
          .five {
            flex: 1;
          }
        }
      }
    }
  }

  .table-x {
    .common-box {
      width: 100%;
      display: flex;
      align-items: center;
      text-align: center;
      border: 1px solid #dcdcdc;
      border-bottom: none;
      font-size: 12px;
      color: #333;
      font-weight: bold;
      .first-box {
        flex: 1;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .second-box {
        flex: 2;
        height: 100%;
        //height: calc(100% - 1px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #dcdcdc;
      }
      .third-box {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .fourth-box {
        width: 80px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .table-title-box {
      height: 40px;
      background-color: #f5f5f5;
    }
    .table-content {
      height: 50px;
      .del-box {
        color: #0064c8;
        cursor: pointer;
        font-size: 14px;
      }
    }
    .table-bottom {
      height: 60px;
      padding: 10px;
      background-color: #f5f5f5;
      border: 1px solid #dcdcdc;
      .data-icon {
        width: 10px;
        height: 10px;
        margin-right: 10px;
      }
      .table-add {
        cursor: pointer;
        background-color: #fff;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
